import { Input } from "waapi/waap-ui/components/Input/Input.js";
import { InputFeedback } from "waapi/waap-ui/components/InputFeedback/InputFeedback.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import React from "react";
import { FieldContent } from "./style.js";
import { BaseInputProps } from "./types.js";

export const BaseInput = ({ labelInfos, feedback, fullWidth, ...attributes }: BaseInputProps): JSX.Element => {
    return (
        <FieldContent fullWidth={fullWidth} gap="2" direction="column">
            {labelInfos && (
                <Text color={labelInfos.color} size={TextSize["X-SMALL"]} weight={TextWeight.SEMIBOLD}>
                    {labelInfos.text}
                </Text>
            )}

            <Input {...attributes} />

            {feedback && <InputFeedback {...feedback} />}
        </FieldContent>
    );
};
